import { type FC } from 'react';

import { useCardOfferDataContext } from '../../../context/selectors';
import { Subtitle } from '../components/Subtitle';

export const SubtitleContainer: FC = () => {
  const { subtitle } = useCardOfferDataContext();

  if (!subtitle) {
    return null;
  }

  return <Subtitle text={subtitle} />;
};
